export default "__VITE_ASSET__Caj2ueHM__"